/**
 * Türkçe biçimli tutar girişi: binlik ayıracı **nokta**, ondalık ayıracı **virgül**
 * (15.000,50). "Satış Ekle" ekranında ürün fiyatı yazılırken kullanılır.
 *
 * Neden: alan düz `type="number"` iken bayi 1.500 ile 15.000'i karıştırıyordu — yazdığı
 * rakam yığını hiç gruplanmadığı için sıfır sayması gerekiyordu. Artık her tuş vuruşunda
 * gruplama uygulanıyor.
 *
 * Ondalık için nokta tuşuna basanı da destekliyoruz: bizim eklediğimiz binlik noktaların
 * ardından her zaman rakam gelir, dolayısıyla **metnin sonundaki** nokta yalnızca
 * kullanıcıdan gelebilir → virgüle çevrilir. Diğer noktalar binlik ayıracı sayılıp atılır.
 */
const MAX_DECIMALS = 2;

export const formatPriceInput = (raw) => {
  const text = String(raw ?? "").replace(/\.$/, ",");
  const cleaned = text.replace(/[^\d,]/g, "");
  if (!cleaned) return "";

  const [integerPart, ...decimalParts] = cleaned.split(",");
  const digits = integerPart.replace(/^0+(?=\d)/, "");
  const grouped = digits.replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  if (decimalParts.length === 0) return grouped;

  // Virgülden sonrası: birden fazla virgül yazılırsa hepsi tek ondalık kısımda birleşir.
  const decimals = decimalParts.join("").slice(0, MAX_DECIMALS);
  return `${grouped || "0"},${decimals}`;
};

/** Görünen metinden sayı. Boş/geçersiz girişte `null` döner (doğrulama buna bakar). */
export const parsePriceInput = (text) => {
  const cleaned = String(text ?? "")
    .replace(/\./g, "")
    .replace(",", ".");
  if (!cleaned || cleaned === ".") return null;
  const value = Number(cleaned);
  return Number.isFinite(value) ? value : null;
};

/** Sayıdan (ör. taslaktan gelen 15000.5) görünen metne: "15.000,5". */
export const formatPriceValue = (value) =>
  value === null || value === undefined || value === ""
    ? ""
    : formatPriceInput(String(value).replace(".", ","));
